export const RED = 1
export const RED_LABEL = 'red'
export const RED_LABEL_NL = 'rood'
export const RED_NAME_URL = 'rode-wijn'
export const WHITE = 2
export const WHITE_LABEL = 'white'
export const WHITE_LABEL_NL = 'wit'
export const WHITE_NAME_URL = 'witte-wijn'

export const WINE_COLORS = {
  [RED]: RED_LABEL,
  [WHITE]: WHITE_LABEL
}

export const WINE_COLORS_NL = {
  [RED]: RED_LABEL_NL,
  [WHITE]: WHITE_LABEL_NL
}

export const WINE_NAMES_URL = {
  [RED]: RED_NAME_URL,
  [WHITE]: WHITE_NAME_URL
}
